export default __webpack_public_path__ + "static/media/obe.91d62fb7.jpg";